import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import api from "@/lib/api";

const fmt = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;

export const OpeningHours = () => {
  const { t } = useLang();
  const h = t.hours;
  const today = new Date().getDay(); // 0=Sun..6=Sat
  const idx = today === 0 ? 6 : today - 1; // map to Mon..Sun array
  const [rows, setRows] = useState(null); // null = fallback to static translations

  useEffect(() => {
    api.get("/store/opening-hours")
      .then((res) => {
        const days = res.data?.days;
        if (!days) return;
        setRows(
          h.days.map((row, i) => {
            const wins = days[String(i)] || [];
            return wins.length
              ? { d: row.d, h: wins.map((w) => `${fmt(w[0])}–${fmt(w[1])}`).join(" · ") }
              : { d: row.d, h: h.closed, closed: true };
          })
        );
      })
      .catch(() => { /* keep static fallback */ });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const list = rows || h.days;

  return (
    <div className="rounded-[1.5rem] bg-white border border-brand/10 p-6 shadow-[0_8px_30px_rgba(42,37,34,0.06)]" data-testid="opening-hours">
      <h3 className="font-heading text-2xl font-semibold text-brand-ink flex items-center gap-2 mb-4">
        <Clock className="h-5 w-5 text-bamboo" /> {h.title}
      </h3>
      <ul className="divide-y divide-brand/10">
        {list.map((row, i) => (
          <li
            key={i}
            className={`flex items-center justify-between gap-4 py-2.5 ${i === idx ? "font-bold text-brand" : "text-brand-ink/80"}`}
            data-testid={`hours-day-${i}`}
          >
            <span className="text-sm">{row.d}{i === idx ? " •" : ""}</span>
            <span className={`text-sm ${row.closed ? "text-rose-500 font-semibold" : ""}`}>{row.h}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
